import React, { useState } from "react";

import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Paper from "@material-ui/core/Paper";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Divider from "@material-ui/core/Divider";

import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import AssessmentRoundedIcon from "@material-ui/icons/AssessmentRounded";
import CategoryRoundedIcon from "@material-ui/icons/CategoryRounded";
import GroupIcon from "@material-ui/icons/Group";
import LocalOfferRoundedIcon from "@material-ui/icons/LocalOfferRounded";
import LocalOfferOutlinedIcon from "@material-ui/icons/LocalOfferOutlined";
import LocalShippingRoundedIcon from "@material-ui/icons/LocalShippingRounded";
import ShoppingCartRoundedIcon from "@material-ui/icons/ShoppingCartRounded";
import StarsRoundedIcon from "@material-ui/icons/StarsRounded";
import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";
import ReceiptIcon from "@material-ui/icons/Receipt";
import ReceiptOutlinedIcon from "@material-ui/icons/ReceiptOutlined";
import PaymentIcon from "@material-ui/icons/Payment";
import LocalShippingIcon from "@material-ui/icons/LocalShipping";
import EmojiPeopleIcon from "@material-ui/icons/EmojiPeople";
import LoyaltyIcon from "@material-ui/icons/Loyalty";
import { Link as RouterLink } from "react-router-dom";
import { useLocation } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  sub: {
    color: "rgba(109, 113, 117, 1)",
    fontSize: "0.9rem",
  },
  selected: {
    borderLeft: "5px solid #42494E",
    paddingLeft: "11px",
  },
}));

function ListItemLink(props) {
  const classes = useStyles();

  const { onClick, selected, icon, primary, show, to, sub } = props;

  const renderLink = React.useMemo(
    () =>
      React.forwardRef((itemProps, ref) => (
        <RouterLink to={to} ref={ref} {...itemProps} />
      )),
    [to]
  );

  return (
    show && (
      <li>
        <ListItem
          selected={selected}
          onClick={onClick}
          button
          component={renderLink}
          classes={{
            selected: classes.selected, //
          }}
        >
          {icon ? (
            <ListItemIcon>{icon}</ListItemIcon>
          ) : (
            <ListItemIcon></ListItemIcon>
          )}
          <ListItemText
            // style={sub ? {fontSize: '0.9rem'} : {fontSize: '1rem'}}
            primary={primary}
            className={sub ? classes.sub : null}
          />
        </ListItem>
      </li>
    )
  );
}

ListItemLink.propTypes = {
  icon: PropTypes.element,
  primary: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
  sub: PropTypes.bool,
  selected: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default function ListRouter(props) {
  const { open } = props;
  const classes = useStyles();
  const location = useLocation();

  const [selectedIndex, setSelectedIndex] = useState(2);

  const handleChildClick = (index, event) => {
    setSelectedIndex(index);
  };

  return (
    <div className={classes.root}>
      <Paper elevation={0}>
        <List>
          {[
            // {
            //   name: 'Profile',
            //   url: '/account',
            //   icon: <AccountCircleIcon />,
            //   show: true,
            //   sub: false,
            // },
            {
              name: "Users",
              url: "/users",
              icon: <AccountCircleIcon />,
              show: true,
              sub: false,
            },
            // {
            //   name: 'All users',
            //   url: '/users',
            //   // icon: <LocalOfferRoundedIcon />,
            //   show: open ? location.pathname.includes('/users') : false,
            //   sub: true,
            // },
            // {
            //   name: 'Add user',
            //   url: '/users/add',
            //   // icon: <LocalOfferRoundedIcon />,
            //   show: open ? location.pathname.includes('/users') : false,
            //   sub: true,
            // },
            {
              name: "Products",
              url: "/products",
              icon: <LocalOfferRoundedIcon />,
              show: true,
              sub: false,
            },
            {
              name: "All products",
              url: "/products",
              // icon: <LocalOfferRoundedIcon />,
              show: open ? location.pathname.includes("/products") : false,
              sub: true,
            },
            // {
            //   name: 'Old Version',
            //   url: '/products/old',
            //   // icon: <LocalOfferRoundedIcon />,
            //   show: open ? location.pathname.includes('/products') : false,
            //   sub: true,
            // },
            {
              name: "Create New",
              url: "/products/new",
              // icon: <LocalOfferRoundedIcon />,
              show: open ? location.pathname.includes("/products") : false,
              sub: true,
            },
            {
              name: "Bulk Upload History",
              url: "/products/upload",
              // icon: <LocalOfferRoundedIcon />,
              show: open ? location.pathname.includes("/products") : false,
              sub: true,
            },
            {
              name: "Reporting",
              url: "/reports/orders",
              icon: <AssessmentRoundedIcon />,
              show: true,
              sub: false,
            },
            {
              name: "Products Ordered",
              url: "/reports/orders",
              show: open ? location.pathname.includes("/reports") : false,
              sub: true,
            },
            {
              name: "Average Margin",
              url: "/reports/average-margin",
              show: open ? location.pathname.includes("/reports") : false,
              sub: true,
            },
            {
              name: "Categories",
              url: "/categories",
              icon: <CategoryRoundedIcon />,
              show: true,
              sub: false,
            },
            // {
            //   name: 'All categories',
            //   url: '/categories',
            //   show: open ? location.pathname.includes('/categories') : false,
            //   sub: true,
            // },
            // {
            //   name: 'Add category',
            //   url: '/categories/add',
            //   show: open ? location.pathname.includes('/categories') : false,
            //   sub: true,
            // },
            {
              name: "Brands",
              url: "/brands",
              icon: <StarsRoundedIcon />,
              show: true,
              sub: false,
            },
            // {
            //   name: 'All brands',
            //   url: '/brands',
            //   show: open ? location.pathname.includes('/brands') : false,
            //   sub: true,
            // },
            // {
            //   name: 'Add brand',
            //   url: '/brands/add',
            //   show: open ? location.pathname.includes('/brands') : false,
            //   sub: true,
            // },
            {
              name: "Suppliers",
              url: "/suppliers",
              icon: <ShoppingCartRoundedIcon />,
              show: true,
              sub: false,
            },
            // {
            //   name: 'All suppliers',
            //   url: '/suppliers',
            //   show: open ? location.pathname.includes('/suppliers') : false,
            //   sub: true,
            // },
            // {
            //   name: 'Add supplier',
            //   url: '/suppliers/add',
            //   show: open ? location.pathname.includes('/suppliers') : false,
            //   sub: true,
            // },
            // {
            //   name: 'Courier',
            //   url: '/couriers',
            //   icon: <LocalShippingRoundedIcon />,
            //   show: true,
            //   sub: false,
            // },
            {
              name: "Orders",
              url: "/orders",
              icon: <MonetizationOnIcon />,
              show: true,
              sub: false,
            },
            {
              name: "Invoices",
              url: "/invoices",
              icon: <ReceiptIcon />,
              show: true,
              sub: false,
            },
            // {
            //   name: "Purchase Orders",
            //   url: "/purchase-orders",
            //   icon: <PaymentIcon />,
            //   show: true,
            //   sub: false,
            // },
            {
              name: "Ordered Products",
              url: "/order-products",
              icon: <LocalOfferOutlinedIcon />,
              show: true,
              sub: false,
            },
            {
              name: "Couriers",
              url: "/couriers",
              icon: <LocalShippingIcon />,
              show: true,
              sub: false,
            },
            // {
            //   name: 'All couriers',
            //   url: '/couriers',
            //   show: open ? location.pathname.includes('/couriers') : false,
            //   sub: true,
            // },
            // {
            //   name: 'Add courier',
            //   url: '/couriers/add',
            //   show: open ? location.pathname.includes('/couriers') : false,
            //   sub: true,
            // },
            {
              name: "Clients",
              url: "/clients",
              icon: <GroupIcon />,
              show: true,
              sub: false,
            },
            {
              name: "Claims",
              url: "/claims",
              icon: <ReceiptOutlinedIcon />,
              show: true,
            },
            {
              name: "User Points",
              url: "/user-points",
              icon: <LoyaltyIcon />,
              show: true,
              sub: false,
            },
            {
              name: "Members",
              url: "/client-users",
              icon: <EmojiPeopleIcon />,
              show: true,
              sub: false,
            },
          ].map((listItem, index) => (
            <ListItemLink
              key={index}
              to={listItem.url}
              primary={listItem.name}
              icon={listItem.icon}
              show={listItem.show}
              onClick={(e) => handleChildClick(index, e)}
              selected={selectedIndex === index}
              sub={listItem.sub}
            />
          ))}
        </List>
        <Divider />
      </Paper>
    </div>
  );
}
